import { useAuthContext } from '@medely/ui-kit/web';
import { useState } from 'react';

export const useIsImpersonating = () => {
  const { isImpersonating } = useAuthContext();
  const [isImpersonateBannerVisible, setIsImpersonateBannerVisible] = useState(isImpersonating);
  return { isImpersonating, isImpersonateBannerVisible, setIsImpersonateBannerVisible };
};
